import React, { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import './HeaderInfo.css';

export const HeaderInfo = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [balanceData, setBalanceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const cookies = new Cookies();
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  useEffect(() => {
    const fetchBalanceData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const token = cookies.get('clickanti_token');
        
        if (!token) {
          throw new Error('Токен авторизации не найден');
        }
        
        const response = await fetch('https://api.clickanti.ru/api/users/balance/', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        
        if (!response.ok) {
          throw new Error(`Ошибка HTTP: ${response.status}`);
        }
        
        const data = await response.json();
        setBalanceData(data);
      } catch (err) {
        console.error('Ошибка при загрузке баланса:', err);
        setError(err instanceof Error ? err.message : 'Неизвестная ошибка');
      } finally {
        setLoading(false);
      }
    };
    
    fetchBalanceData();
  }, []);
  
  const formatVisits = (visits) => {
    if (visits === undefined || visits === null) return '0';
    return visits.toLocaleString('ru-RU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };
  
  const formatTariffEndDate = (dateString) => {
    if (!dateString) return 'дата не указана';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long'
    });
  };
  
  const getEarliestTariff = () => {
    return balanceData?.tariffs_overview?.earliest_expiring_tariff || null;
  };
  
  const getVisitsPercentage = () => {
    const tariff = getEarliestTariff();
    if (!tariff || !tariff.visits_limit || tariff.visits_limit === 0) return 0;
    
    const usedVisits = tariff.visits_used || 0;
    const percentage = Math.round((usedVisits / tariff.visits_limit) * 100);
    return Math.min(percentage, 100);
  };
  
  if (loading) {
    return (
      <div className="headerInfo">
        <div className="headerInfo_container">
          <div className="headerInfo_mainRow">
            <div className="tariff_section">
              <span className="loading_text">Загрузка...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="headerInfo">
        <div className="headerInfo_container">
          <div className="headerInfo_mainRow">
            <div className="tariff_section">
              <span className="error_text">Ошибка загрузки</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  const earliestTariff = getEarliestTariff();
  const visitsPercentage = getVisitsPercentage();
  
  return (
    <div className="headerInfo">
      <div className="headerInfo_container">
        <div className="headerInfo_mainRow">
          {/* ТАРИФ */}
          {earliestTariff ? (
            <div className="tariff_section">
              <div className="tariff_content">
                <div className="tariff_visits">
                  <div className="visits_progress_container">
                    <div className="visits_progress_bar">
                      <div 
                        className="visits_progress_fill"
                        style={{ width: `${visitsPercentage}%` }}
                      ></div>
                    </div>
                    <div className="visits_counts">
                      <span className="visits_current">
                        {formatVisits(earliestTariff.remaining_visits)}
                      </span>
                      <span className="visits_separator">/</span>
                      <span className="visits_total">
                        {formatVisits(earliestTariff.visits_limit)}
                      </span>
                    </div>
                  </div>
                  
                  <div className="tariff_expiry">
                    <span className="expiry_label">до </span>
                    <span className="expiry_date">
                      {formatTariffEndDate(earliestTariff.end_date)}
                    </span>
                  </div>
                </div>
                
                {!isMobile && earliestTariff.tariff_name && (
                  <div className="tariff_name">
                    Тариф "{earliestTariff.tariff_name}"
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="tariff_section">
              <div className="no_tariff_message">
                Нет активного тарифа
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};